(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ConfigParamDeleteController',ConfigParamDeleteController);

    ConfigParamDeleteController.$inject = ['$uibModalInstance', 'entity', 'ConfigParam'];

    function ConfigParamDeleteController($uibModalInstance, entity, ConfigParam) {
        var vm = this;

        vm.configParam = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	ConfigParam.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
